import React, { useState } from 'react';
import { Grid, Radio, RadioGroup, FormControlLabel } from '@mui/material';
import ViewImageModal from './viewImageModal';

function RadioGroupCustomWithImage(props) {
  const [open, setOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const { defaultValue, items, isVE, imageUrls, handleClick, onChange } = props;

  const getImageURL = memberValue => {
    if (imageUrls && imageUrls?.length > 0) {
      if (imageUrls.filter(x => x.componentName == memberValue).length > 0)
        return imageUrls.filter(x => x.componentName == memberValue)[0]
          .imageUrl;
      else return '';
    }
  };

  const handleEnlargeImage = imageUrl => {
    setOpen(true);
    setImageUrl(imageUrl);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <RadioGroup
        value={defaultValue}
        onChange={e => {
          onChange(e);
        }}
      >
        {items.map((val, i) => {
          return (
            <Grid container key={val.description + '_' + i}>
              <Grid item lg={8} md={8}>
                <FormControlLabel
                  key={i}
                  value={val?.name}
                  control={<Radio disabled={isVE} size="small" />}
                  label={val?.description}
                  className={val?.state == 'green' ? '' : 'gray-shade-option'}
                  onClick={handleClick}
                />
              </Grid>
              {getImageURL(val?.name) && (
                <Grid item lg={4} md={4}>
                  <div className="image-div">
                    <img
                      src={getImageURL(val?.name)}
                      className="option-image"
                    />
                  </div>
                </Grid>
              )}
              {getImageURL(val?.name) && (
                <Grid item lg={12} md={12}>
                  <div
                    className="enlarge-image align-right"
                    onClick={() => handleEnlargeImage(getImageURL(val?.name))}
                  >
                    Enlarge Image
                  </div>
                </Grid>
              )}
            </Grid>
          );
        })}
      </RadioGroup>

      {open && (
        <ViewImageModal
          open={open}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      )}
    </>
  );
}

export default RadioGroupCustomWithImage;
